import { handleError } from "../apiUtils";

export async function login(username: string, password: string) {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const loginInfo = {
    username: username,
    password: password,
  };

  const data = JSON.stringify(loginInfo);

  try {
    const response = await fetch(baseUrl + "/api/users/authenticate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        accept: "application/json, text/plain, */*",
      },
      body: data,
    });

    // Handle different response statuses
    if (!response.ok) {
      // If the response is not OK (e.g., 400, 401, 500, etc.)
      const errorText = await response.text();

      if (response.status === 400) {
        // Handle validation error from the server
        throw new Error(`Server validation error: ${errorText}`);
      } else if (response.status === 401) {
        // Unauthorized access (incorrect username/password)
        throw new Error("Invalid username or password.");
      } else {
        // Other errors (e.g., server issues)
        throw new Error(`Unexpected error: ${errorText}`);
      }
    }
    // Assuming a successful response, parse the JSON response
    const responseData = await response.json();
    if (responseData.token) {
      localStorage.setItem("userAuthorized", "true");
      const { token, ...userWithoutToken } = responseData; // Exclude the token
      localStorage.setItem("currentUser", JSON.stringify(userWithoutToken));
      localStorage.setItem("token", responseData.token); // Save token in localStorage
    } else {
      throw new Error("Authentication successful but token is missing.");
    }

    return responseData; // Return the response data to the caller (if needed)
  } catch (err) {
    handleError(err); // Assuming handleError shows user-friendly message
  }
}
